import { getCurrentInstance as K, computed as P, watch as $, onMounted as U } from "vue";
import { buildProp as h, definePropType as w } from "./index601.js";
import { isFunction as f } from "./index575.js";
import { isBoolean as _ } from "./index565.js";
import { isClient as d } from "./index599.js";
const A = h({
  type: w(Boolean),
  default: null
}), I = h({
  type: w(Function)
}), H = (s) => {
  const u = `update:${s}`, c = `onUpdate:${s}`, x = [u], B = {
    [s]: A,
    [c]: I
  };
  return {
    useModelToggle: ({
      indicator: o,
      toggleReason: r,
      shouldHideWhenRouteChanges: g,
      shouldProceed: v,
      onShow: m,
      onHide: M
    }) => {
      const n = K(), { emit: p } = n, t = n.props, i = P(
        () => f(t[c])
      ), T = P(() => t[s] === null), b = (e) => {
        o.value !== !0 && (o.value = !0, r && (r.value = e), f(m) && m(e));
      }, y = (e) => {
        o.value !== !1 && (o.value = !1, r && (r.value = e), f(M) && M(e));
      }, E = (e) => {
        if (t.disabled === !0 || f(v) && !v())
          return;
        const l = i.value && d;
        l && p(u, !0), (T.value || !l) && b(e);
      }, a = (e) => {
        if (t.disabled === !0 || !d) return;
        const l = i.value && d;
        l && p(u, !1), (T.value || !l) && y(e);
      }, C = (e) => {
        _(e) && (t.disabled && e ? i.value && p(u, !1) : o.value !== e && (e ? b() : y()));
      }, F = () => {
        o.value ? a() : E();
      };
      return $(() => t[s], C), g && n.appContext.config.globalProperties.$route !== void 0 && $(
        () => ({
          ...n.proxy.$route
        }),
        () => {
          g.value && o.value && a();
        }
      ), U(() => {
        C(t[s]);
      }), {
        hide: a,
        show: E,
        toggle: F,
        hasUpdateHandler: i
      };
    },
    useModelToggleProps: B,
    useModelToggleEmits: x
  };
};
export {
  H as createModelToggleComposable
};
